module.exports = __webpack_public_path__ + "img/15-avatar male.b05947bf.png";